import { BarChart } from "@jana-technology/platform-ui";

import { ChartCard } from "components/charts";
import { OverallRiskComparison } from "components/charts/RiskComparison";
import { useGlobalFiltersContext } from "contexts/filters/global-filters";
import { useRiskManagementFiltersContext } from "contexts/filters/risk-management-filters";
import { xAccessor } from "helpers/charts";
import { useOverallRiskCharts } from "hooks/queries";
import { useBaseBarChartProps } from "hooks/useBaseBarChartProps";
import { ChartsLayout } from "layouts/ChartsLayout";

export const RiskManagementOverallRiskCharts = () => {
  const { appliedWell } = useGlobalFiltersContext();
  const { appliedRiskMitigationId } = useRiskManagementFiltersContext();

  const [hierarchyId, wellName] = appliedWell;

  const {
    overallRiskByThreatSeries,
    overallRiskByConsequenceSeries,
    overallRiskByOutcomeScenarioSeries,
    overallRiskDataKeys,
    overallRiskChartsQueryResult,
  } = useOverallRiskCharts({
    skip: !wellName.length,
    variables: {
      hierarchyId,
      wellName,
      riskMitigationTypeId: appliedRiskMitigationId,
    },
  });

  const baseBarChartProps = useBaseBarChartProps();

  return (
    <ChartsLayout>
      <ChartCard
        loading={overallRiskChartsQueryResult.loading}
        heading="Risk by Threat"
      >
        <BarChart
          {...baseBarChartProps}
          withBarLabels
          xAxisLabel="Threat"
          yAxisLabel="Threat Risk"
          xPadding={0.2}
          withLegend={false}
          chartName="Risk by Threat"
          xAccessor={xAccessor}
          data={overallRiskByThreatSeries}
          dataKeys={overallRiskDataKeys}
        />
      </ChartCard>
      <ChartCard
        loading={overallRiskChartsQueryResult.loading}
        heading="Risk by Consequence"
      >
        <BarChart
          {...baseBarChartProps}
          withBarLabels
          xAxisLabel="Consequence"
          yAxisLabel="Overall Risk"
          chartName="Risk by Consequence"
          xAccessor={xAccessor}
          data={overallRiskByConsequenceSeries}
          dataKeys={overallRiskDataKeys}
        />
      </ChartCard>
      <ChartCard
        loading={overallRiskChartsQueryResult.loading}
        heading="Risk by Outcome Scenario"
      >
        <BarChart
          {...baseBarChartProps}
          withBarLabels
          xAxisLabel="Outcome Scenario"
          yAxisLabel="Overall Risk"
          chartName="Risk by Outcome Scenario"
          xAccessor={xAccessor}
          data={overallRiskByOutcomeScenarioSeries}
          dataKeys={overallRiskDataKeys}
        />
      </ChartCard>
      <OverallRiskComparison />
    </ChartsLayout>
  );
};

export default RiskManagementOverallRiskCharts;
